import { render } from "./pc_destination_mail.vue?vue&type=template&id=741e6b15&scoped=true"
import script from "./pc_destination_mail.vue?vue&type=script&lang=js"
export * from "./pc_destination_mail.vue?vue&type=script&lang=js"

import "./pc_destination_mail.vue?vue&type=style&index=0&id=741e6b15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741e6b15"]])

export default __exports__